export const FILTERED_ENTITIES = '/GetFilteredEntities';
export const AUTH = '/Auth';
export const GET_USER_ACCESS_TOKEN = '/GetUserAccessToken';
export const UPLOAD_FILE = '/UploadFile';
export const REMOVE_FILE = '/RemoveFile';
export const CREATE_LOG = '/CreateLog';
export const CREATE_BULK_ENTITY = '/CreateBulkEntity';
//tlkp material
export const TLKP_MATERIAL = '/TlkpMaterial';
export const TLKP_MATERIAL_WITH_PRODUCATION_PROCESS =
  '/GetMaterialWithProductionProcess';
//tlkp production station
export const TLKP_PRODUCTION_STATION = '/TlkpProductionStation';

//tlkp roles
export const TLKP_ROLES = '/Role';
export const TLKP_ROLES_WITH_PERMISSIONS = '/GetRolesWithPermissions';

//tlkp roles permissions
export const TLKP_ROLES_PERMISSONS = '/RolePermission';
export const TLKP_ROLES_PERMISSONS_UPDATE = '/UpdateRolePermissions';

//callRail
export const CALL_RAIL = '/callRail';
export const CALLS = '/calls';
export const CALL_RAIL_BAD_CALL_REASON = '/crm_CallRailReason';
//tbl parts
export const TBL_PARTS = '/TblPart';
export const CHECK_PART_NUMBER_EXIST = '/CheckPartNumberExist';
export const GET_FILTERED_PART = '/GetFilteredParts';
export const TBL_PART_CHANGE_LOG = '/TblPartChangeLog';
export const GET_DISTINCT_PART_CATEGORIES = '/GetDistinctPartCategories';
export const GET_INVENTORY_SUMMARY_BY_PART = '/GetInventorySummaryByPart';
export const TBL_PART_CATEGORY = '/tblPartCategory';

// tlkp permissions
export const TLKP_PERMISSIONS = '/Permission';

export const TBL_CUSTOMER_CHANGE_LOG = '/TblCustomerChangeLog';
export const TBL_CUSTOMER_DISCOUNT_CHANGE_LOG = '/TblCustomerDiscountChangeLog';

// tlkp customer contact
export const TLKP_CUSTOMER_CONTACT = '/TblCustomerContact';
export const GET_ALL_CUSTOMER_CONTACT_BY_CUSTOMER_ID =
  '/GetAllCustomerContactByCustomerId';

// tblCustomerDiscount
export const TBL_CUSTOMER_DISCOUNT = '/tblCustomerDiscount';
export const GET_CUSTOMER_DISCOUNT_OR_PRICE = '/GetCustomerDiscountOrPrice';

// tlkp part assembly
export const TBL_PART_ASSEMBLY = '/TblPartAssembly';
export const POST_PART_ASSEMBLY_WITH_ITEMS = '/PostPartAssemblyWithItems';
export const GET_PART_ASSEMBLY_WITH_ITEMS_BY_ID =
  '/GetPartAssemblyWithItemsById';
export const UPDATE_PART_ASSEMBLY_WITH_ITEMS = '/UpdatePartAssemblyWithItems';
export const CHECK_ASSEMBLY_NUMBER_EXIST = '/CheckAssemblyNumberExist';
export const GET_ASSEMBLY_LIST_BY_PART_ID = '/GetAssemblyListByPartId';
export const GET_FILTERED_PARTS_ASSEMBLY = '/GetFilteredPartsAssembly';
export const CLONE_ASSEMBLY_DATA_WITH_ITEMS = '/CloneAssemblyDataWithItems';
export const GET_ASSEMBLY_COMPLETE_DETAILS = '/GetAssemblyCompleteDetails';

// tlkp part assembly items
export const TBL_PART_ASSEMBLY_ITEM = '/TblPartAssemblyItem';
export const CHECK_ASSEMBLY_WITH_SAME_PART_QTY_EXIST =
  '/CheckIfAssemblyExistsWithSamePartsAndQty';

// tlkp part assembly other link
export const TBL_PART_ASSEMBLY_OTHER_LINK = '/TblPartAssemblyOtherLink';

//tbl assembled assembly process
export const TBL_ASSEMBLED_ASSEMBLY_PROCESS = '/TblAssembledAssemblyProcess';
export const GET_PRE_ASSEMBLED_ASSEMBLY_PROCESS =
  '/GetPreAssembledAssemblyData';
export const COMPLETE_PRE_ASSEMBLED_ASSEMBLY_PROCESS =
  '/CompletePreAssembledAssembly';

// tbl ship To Location
export const TLKP_SHIP_TO_LOCATION = '/TblCustomerShipToLocation';
export const GET_CUSTOMER_SHIP_TO_LOCATION_BY_CUSTOMER_ID =
  '/getCustomerShipToLocationByCustomerId';
export const UPDATE_LAT_AND_LNG_BY_SHIP_TO_LOCATION_ID =
  '/UpdateLatAndLngByShipToLocationId';

//tbl customer order
export const TLKP_CUSTOMER_ORDER = '/TblCustomerOrder';
export const GET_ROOT_ORDER_DETAILS = '/GetRootOrderDetails';
export const TBL_CUSTOMER_ORDER = '/TblCustomerOrder';
export const GET_FILTERED_ORDERS = '/GetFilteredOrders';
export const UNSCHEDULE_ORDER_BY_ORDER_ID = '/UnscheduleOrderByOrderId';
export const IS_PONUMBER_EXIST = '/IsPoNumberExist';
export const GET_AFFECTED_ORDERS_FOR_PART_CHANGE =
  '/GetAffectedOrdersForPartChange';
export const REFRESH_ORDER_ITEMS_FROM_PART_WORKFLOW =
  '/RefreshOrderItemsFromPartWorkflow';
export const AUTO_CLOSE_BYPASS_ORDER_AFTER_PACKAGING ='/AutoCloseBypassOrderAfterPackaging'
//tbl customer order item
export const TLKP_CUSTOMER_ORDER_ITEM = '/TblCustomerOrderItem';
export const DELETE_ALL_CUSTOMER_PRODUCTION_DATA_BY_ORDER_ITEM_ID =
  '/DeleteAllProductionAndCustomerOrderItemDataById';
export const GET_ORDER_ITEM_FOR_PACKAGING_SCREEN =
  '/GetOrderItemForPackagingScreen';
export const GET_ORDER_ITEM_FOR_SHIPPING_SCREEN =
  '/GetOrderItemForShippingScreen';
export const CREATE_CUSTOMER_ORDER_PRODUCTION_ENTITY_BY_ORDERITEMID =
  '/CreateCustomerOrderProductionEntityByOrderItemId';
export const CREATE_CUSTOMER_ORDER_PRODUCTION_WITH_MAKEUP_ENTITY_BY_ORDERITEMID =
  '/CreateCustomerOrderProductionWithMakeupEntityByOrderItemId';
export const GET_ORDER_ITEMS_WITH_STATION = '/GetOrderItemsWithStation';
export const CREATE_BULK_ORDER_ITEMS_WITH_SUB_PARTS =
  '/CreateBulkOrderItemsWithSubParts';
export const UPDATE_ORDER_ITEM_WITH_SUB_ITEMS = '/UpdateOrderItemWithSubItems';
export const UPDATE_PRODUCTION_ORDER_ITEM_WITH_SUB_ITEMS =
  '/UpdateProductionOrderItemWithSubItems ';
export const GET_LINKED_MAKEUP_ITEM = '/LinkedMakeupItem';

export const PROCESS_CUSTOMER_ORDER_FOR_PRODUCTION =
  '/ProcessCustomerOrderForProduction';
export const PROCESS_CUSTOMER_ORDERITEM_FOR_PRODUCTION =
  '/ProcessCustomerOrderItemForProduction';
export const PROCESS_CUSTOMER_ORDERITEM_FOR_PRODUCTION_MAKEUP =
  '/ProcessCustomerOrderItemForProductionMakeup';
export const CREATE_MAKEUP_ITEM_FOR_PRDUCTION =
  '/CreateMakeupItemForProduction';
export const CREATE_MAKEUP_ITEM_FOR_PACKING = '/CreateMakeupItemForPacking';
// tlkp customer
export const TBL_CUSTOMER = '/TblCustomer';
export const UPDATE_LAT_AND_LNG_BY_CUSTOMER_ID = '/UpdateLatAndLngByCustomerId';
export const GET_ALL_CUSTOMERS = '/GetAllCustomers';
//Tbl labels Main
export const TBL_LABEL_MAINS = '/TblCustomerOrderPackagingLabelsMain';

//Tbl label details
export const TBL_LABEL_DETAILS = '/TblCustomerOrderPackagingLabelsDetail';

//order change log
export const ORDER_CHANGE_LOG = '/OrderChangeLog';

//tbl orderItem change log
export const TBL_ORDER_ITEM_CHANGE_LOG = '/TblOrderItemChangeLog';
export const GET_ORDER_ITEM_CHANGE_LOG_BY_ORDERID =
  '/GetOrderItemChangeLogByOrderId';
export const ADD_ORDER_ITEM_CHANGE_LOG = '/AddOrderItemChangeLog';
// tlkp staff
export const TLKP_STAFF = '/Tlkpstaff';
export const CHECK_USERNAME_EXIST = '/CheckUsernameExist';
export const GET_USER_PERMISSION = '/GetUserPermission';
export const CHECK_OLD_PASSWORD = '/CheckOldPassword';
export const GET_LOGGED_IN_USER_TEAM_DETAILS = '/GetLoggedInUserTeamDetails';
export const TBL_STAFF_PAID_TIME = '/tblStaffPaidTime';
export const ROLLOVER = '/rollover';
export const RESET_ALL = '/reset-all';
export const RESET = '/reset';
export const TLKP_STAFF_CHANGE_LOG = '/TlkpStaffChangeLog';

//tblStaffPersonalBest
export const TBL_STAFF_PERSONAL_BEST = '/tblStaffPersonalBest';

//tblStaffPointInfraction
export const TBL_STAFF_POINT_INFRACTION = '/tblStaffPointInfraction';

//tbl hardware
export const TBL_HARDWARE_CATEGORY = '/tblHardwareCategory';
export const TBL_HARDWARE_TYPE = '/tblHardwareType';
export const TBL_HARDWARE_PRODUCT = '/tblHardwareProduct';

//tbl brush
export const TBL_BRUSH = '/tblBrush';
export const TBL_BRUSH_TYPE = '/tblBrushType';
export const TBL_PART_ASSEMBLY_BRUSH = '/tblPartAssemblyBrush';
export const TBL_PART_ASSEMBLY_BRUSH_TYPE = '/tblPartAssemblyBrushType';

export const TBL_PART_ASSEMBLY_MANUFACTURE = '/tblPartAssemblyManufacture';
// tlkp staff role
export const STAFF_ROLE = '/StaffRole';

// tlkp production process
export const TLKP_PRODUCTION_PROCESS = '/TlkpProductionProcess';

// tbl checklist template
export const TBL_CHECKLIST_TEMPLATE = '/tblChecklistTemplate';
export const TBL_CHECKLIST_TEMPLATE_BY_PART_ID = '/part';

// tbl checklist template step
export const TBL_CHECKLIST_TEMPLATE_STEP = '/tblChecklistTemplateStep';

//tbl checklist template part
export const TBL_CHECKLIST_TEMPLATE_PART = '/tblChecklistTemplatePart';
export const TBL_CHECKLIST_TEMPLATE_PART_BY_PARTID = '/part';
export const TBL_CHECKLIST_TEMPLATE_PART_BY_TEMPLATEID = '/template';

//tbl checkList instance
export const TBL_CHECKLIST_INSTANCE = '/tblChecklistInstance';
export const TBL_CHECKLIST_REPORT = '/GetCheckListReport';
export const TBL_CHECKLIST_INSTANCE_CREATE = '/create';
export const TBL_CHECKLIST_STEP = '/step';
export const TBL_CHECKLIST_STEP_COMPLETE = '/complete';

// tlkp color
export const TLKP_COLOR = '/TlkpColor';

// tlkp ply Matrix
export const TLKP_PLY_MATRIX = '/TlkpPlyMatrix';

// Tlkp Carrier
export const TLKP_CARRIER = '/TlkpCarrier';

// Tbl Commodity Density Mapping
export const TBL_COMMODITY_DENSITY_MAPPING = '/TblCommodityDensityMapping';

// tbl customer Order Packaging
export const TBL_CUSTOMER_ORDER_PACKAGING = '/TblCustomerOrderPackaging';

// tbl Customer Order Boxes
export const TBL_CUSTOMER_ORDER_BOXES = '/TblCustomerOrderBox';

//tbl customer order loading instruction
export const TBL_ORDER_LOADING_INSTRUCTION =
  '/TblCustomerOrderLoadingInstruction';

//tlkp payment Term
export const TLKP_PAYMENT_TERM = '/TlkpPaymentTerm';

// tbl customer order other link
export const TBL_CUSTOMER_ORDER_OTHER_LINK = '/TblCustomerOrderOtherLink';

// TblCustomerOrderShipment
export const TBL_CUSTOMER_ORDER_SHIPMENT = '/TblCustomerOrderShipment';
export const GET_ORDER_SHIPMENT_BY_ORDER_ID = '/GetOrderShipmentByOrderId';
export const GET_COMPLETED_SHIPMENT_BY_CUSTOMER_ID =
  '/GetCompletedShipmentByCustomerId';

//shipment
export const SHIPMENT = '/Shipment';
export const GET_UPS_SHIPMENT_CARGE_FOR_ESTIMATE =
  '/GetUpsShipmentChargeForEstimates';
export const GET_LTL_SHIPMENT_CARGE_FOR_ESTIMATE =
  '/GetLtlShipmentChargeForEstimates';
export const USE_ESTIMATE = '/use-estimate';
export const SELECTED_ESTIMATE = '/selected-estimate';
export const BOOK_SELECTED_ESTIMATE = '/book-selected-estimate';

export const TBL_CUSTOMER_ORDER_SHIPPING_ESTIMATE_SELECTION =
  '/TblCustomerOrderShippingEstimateSelection';
// tblCustomerOrderShipmentTrackingNumber

export const TBL_CUSTOMER_ORDER_SHIPMENTS_TRACKING_NUMBER =
  '/TblCustomerOrderShipmentsTrackingNumber';

// TblCustomerOrderBolshipLink
export const TBL_CUSTOMER_ORDER_BOL_SHIPLINK = '/TblCustomerOrderBolshipLink';

// GetCompletedShipmentByStaffId
export const GET_COMPLETED_SHIPMENT_BY_STAFFID =
  '/GetCompletedShipmentByStaffId';

// GetUpsShipmentChargeForOrder
export const GET_UPS_SHIPMENT_CHARGE_FOR_ORDER =
  '/GetUpsShipmentChargeForOrder';
// GetLtlShipmentChargeForOrder
export const GET_LTL_SHIPMENT_CHARGE_FOR_ORDER =
  '/GetLtlShipmentChargeForOrder';

export const UPS_SHIP = '/ups/ship';
export const UPS = '/ups';
export const VOID = '/void';
export const SPEEDSHIP_BOOK = '/speedship/book';
export const SPEEDSHIP_BOOK_CANCEL = '/speedship/cancel';

//tblShipmentDocumnet
export const TBL_SHIPMENT_DOCUMNET = '/TblShipmentDocument';

// tbl Packaging Order Status
export const TBL_PACKAGING_ORDER_STATUS = '/TlkpPackagingOrderStatus';

// InvokeOrdersReadyforShipping
export const INVOKE_ORDERS_READY_FOR_SHIPPING = '/InvokeOrdersReadyforShipping';

// InvokeOrdersReadyforPackaging
export const INVOKE_ORDERS_READY_FOR_PACKAGING =
  '/InvokeOrdersReadyforPackaging';

// role
export const ROLE = '/Role';
export const GET_ROLE_PERMISSIONS_BY_ROLE_ID = '/GetRolePermissionsByRoleId';
export const GET_ROLE_PERMISSIONS_BY_USER_ID = '/GetRolePermissionsByUserId';

//Permission
export const PERMISSION = '/Permission';

// tlkp width
export const TLKP_WIDTH = '/TlkpWidth';

// TlkpHeaderSize
export const TLKP_HEADER_SIZE = '/TlkpHeaderSize';

// TlkpAttachmentMatrix
export const TLKP_ATTACHMENT_MATRIX = '/TlkpAttachmentMatrix';

// ProductionProcessStation
export const PRODUCTION_PROCESS_STATION = '/ProductionProcessStation';

// production station
export const PRODUCTION_STATION = '/ProductionStation';
export const INVOKE_GET_PRODUCTION_STATION_SP = '/InvokeGetProductionStationSP';

// CustomerOrderProduction
export const TBL_CUSTOMER_ORDER_PRODUCTION = '/TblCustomerOrderProduction';
export const CREATE_CUSTOMER_ORDER_PRODUCTION_BULK_ENTITY_BY_ORDER_ID =
  '/CreateCustomerOrderProductionBulkEntityByOrderId';
export const MARK_AS_COMPLETED_CUSTOMER_ORDER_PRODUCTION =
  '/MarkAsCompletedCustomerOrderProduction';
export const MAKEUP_QTY_REQUEST = '/MakeupQtyRequest';
export const GET_STATION_HISTORY_BY_ORDER_ITEM_ID =
  '/GetStationHistoryByOrderItemId';
export const UNDO_CURRENT_PRODUCTION_STATION_DATA =
  '/UndoCurrentProductionStationData';
export const DELETE_ORDER_PRODUCTION_DATA_BY_ORDER_ITEM_ID =
  '/DeleteOrderProductionDataByOrderItemId';
export const DELETE_ORDER_ITEM_DATA_BY_ID = '/DeleteOrderItemDataById';
export const PARTIAL_QTY_REQUEST = '/PartialQtyRequest';
export const TBL_COMPLETE1_ORDER_ITEM_PRODUCTION =
  '/tblComplete1OrderItemProduction';
export const DELETE_ALL_COMPLETE1_DATA_BY_PRODUCTION_ID =
  '/DeleteAllComplete1DataByProductionId';
export const GET_SUB_PART_LIST_FOR_MAKEUP_BY_ORDER_ITEM_ID =
  '/GetSubPartListForMakeupByOrderItemId';

export const MAKEUP_QTY_REQUEST_FOR_CUSTOMER_ORDER =
  '/MakeupQtyRequestForCustomerOrder';
export const DELETE_ORDER_ITEM_DATA_BY_ASSEMBLY_ID =
  '/DeleteOrderItemDataByAssemblyId';
export const DELETE_ORDER_ITEM_DATA_BY_ORDER_ID =
  '/DeleteOrderItemDataByOrderId';
export const DELETE_ORDER_ITEM_DATA_BY_KIT_ID = '/DeleteOrderItemDataByKitId';

export const PARTIAL_QTY_COMPLETE = '/PartialQtyComplete';
export const COMPLETE_LAST_STATION = '/CompleteLastStation';

// holiday
export const HOLIDAY = '/Holiday';

// bun
export const TLKP_BUN_MATRIX = '/tlkpBunMatrix';

// report
export const GET_USER_ACTIVITY_WITH_STATION_DETAIL =
  '/GetUserActivityWithStationDetail';
export const GET_CUSTOMER_OPEN_ORDERS = '/GetCustomerOpenOrders';
export const GET_CUSTOMER_OPEN_ORDERS_BY_PRODUCTION_PROCESS_ID =
  '/GetCustomerOpenOrdersByProductionProcessId';
export const GET_MAKEUP_PART_REPORT_DATA = '/GetMakeupPartReportData';
export const GET_MAKEUP_PART_DETAIL_REPORT_DATA_BY_PART_ID =
  '/GetMakeupPartDetailReportDataByPartId';
export const GET_USER_ACTIVITY_WITH_STATION_DETAIL_BY_DATE =
  '/GetUserActivityWithStationDetailByDate';
export const GET_USER_PERSONAL_BEST_AND_TODAY_COUNT =
  '/GetUserPersonalBestAndTodayCount';
export const GET_UTILIZATION_REPORT = '/GetUtilizationReport';
export const REPORT = '/Report';
export const GET_UTILIZATION_REPORT_BY_WORKFLOW_ID =
  '/GetUtilizationReportByWorkflowId';
export const GET_COMPLETED_SHIPMENT_BY_CARRIERS =
  '/GetCompletedShipmentByCarriers';
export const SEND_TRACKING_REPORT = '/SendTrackingReport';
export const GET_AVERAGE_DAYS_TO_SHIP_REPORT_DATA =
  '/GetAverageDaysToShipReportData';
export const GET_AVERAGE_DAY_BY_DAY_TO_SHIP_REPORT_DATA =
  '/GetAverageDayByDayToShipReportData';
// CRM ENDPOINTS

//leadSource
export const CRM_LEADSOURCE = '/crm_LeadSource';

// lead
export const CRM_LEAD = '/crm_Lead';

// opportunity
export const CRM_OPPORTUNITY = '/crm_Opportunity';

//activity
export const CRM_ACTIVITY = '/crm_activity';

// cost method
export const COST_METHOD = '/CostMethod';

// /ComponentMaster
export const COMPONENT_MASTER = '/ComponentMaster';

// PartComponent
export const PART_COMPONENT = '/PartComponent';
export const GET_FILTERED_PART_COMPONENT = '/GetFilteredPartComponent';
export const CAN_ADD_SUB_PART = '/CanAddSubPart';
// sub part
export const TBl_SUB_PART = '/TblSubPart';

//PartHardware
export const PART_HARDWARE = '/tblPartHardware';

// customerEstimate
export const CRM_CUSTOMER_ESTIMATE = '/crm_CustomerEstimate';

// crm_CustomerEstimateItem
export const CRM_CUSTOMER_ESTIMATE_ITEM = '/crm_CustomerEstimateItem';
export const GET_FILTERED_ESTIMATES = '/GetFilteredEstimates';

// crm_CustomerEstimateDescriptionLine
export const CRM_CUSTOMER_ESTIMATE_DESCRIPTION_LINE =
  '/crm_CustomerEstimateDescriptionLine';
export const DELETE_ALL_DESCRIPTION_LINES_BY_ESTIMATE_ID =
  '/DeleteAllByEstimateId';

// CRM_CUSTOMERCOMMUNICATION
export const CRM_CUSTOMER_COMMUNICATION = '/crm_CustomerCommunication';
// GETMANAGERACTIVITYBYSTATIONID
export const GET_MANAGER_ACTIVITY_BY_STATION_ID =
  '/GetManagerActivityByStationId';

// CRM_MANUFACTURE
export const CRM_MANUFACTURE = '/crm_Manufacture';

// crm_ManufacturerPart
export const CRM_MANUFACTURER_PART = '/crm_ManufacturerPart';

// Widgets Endpoints //

// Widget
export const WIDGET = '/Widget';

// UserWidget
export const USER_WIDGET = '/UserWidget';
export const GET_DAILY_PART_WIDGET_DATA_BY_STATION =
  '/GetDailyPartWidgetDataByStation';

// SchedulePartWidget
export const GET_SCHEDULED_PART_WIDGET_DATA_BY_STATION =
  '/GetScheduledPartWidgetDataByStation';

// e-commerce

// store items
export const ECG_STORE_ITEM = '/ECG_StoreItem';
export const GET_ALL_STORE_ITEM_DETAILS = '/GetAllStoreItemDetails';
// store sections
export const ECG_STORE_SECTION = '/ECG_StoreSection';

// storeQuestions
export const ECG_STORE_SECTION_QUESTION = '/ECG_StoreSectionQuestion';

// ECG_StoreSectionPartOrAssembly
export const ECG_STORE_SECTION_PART_OR_ASSEMBLY =
  '/ECG_StoreSectionPartOrAssembly';

// ECG_QUESTION
export const ECG_QUESTION = '/ECG_Question';

// ECG_CATEGORY
export const ECG_CATEGORY = '/ECG_Category';

// ECG_PARTANDSTORECATEGORY
export const ECG_PART_AND_STORE_CATEGORY = '/ECG_PartAndStoreCategory';
export const GET_CATEGORY_DETAILS_BY_ID = '/GetCategoryDetailsById';
export const DELETE_ALL_CATEGORY_DATA_ID = '/DeleteAllCategoryDataId';

// ECG_PARTCOLORIMAGE
export const ECG_STORE_SECTION_COLOR_IMAGE = '/ECG_StoreSectionColorImage';

// ECG_PARTCOLORIMAGE
export const ECG_PART_COLOR_IMAGE = '/ECG_PartColorImage';

export const TBL_PART_ASSEMBLY_CHANGE_LOG = '/tblPartAssemblyChangeLog';
export const TBL_PART_ASSEMBLY_ITEM_CHANGE_LOG =
  '/tblPartAssemblyItemChangeLog';

export const ECG_BANNER_CAROUSEL_IMAGES = '/ECG_Banner_Carousel_Images';

export const ECG_CONTACTUS = '/ECG_ContactUs';
export const ECG_QUOTEFORDOOR = '/ECG_QuoteForDoor';
export const ECG_REQUESTQUOTE = '/ECG_RequestQuote';

export const GET_CUSTOMER_ORDER_REPORT = '/GetCustomerOrderReport';
export const SEND_ESTIMATION_PDF = '/SendEstimationPdf';
export const CREATE_ESTIMATION_FROM_ORDER = '/CreateEstimationFromOrder';
export const DELETE_ALL_ITEM_BY_CUSTOMER_ESTIMATE_ID =
  '/DeleteAllItemByCustomerEstimateId';
export const CRM_CUSTOMER_ESTIMATE_ITEM_GROUPS =
  '/crm_CustomerEstimateItemGroups';

export const GET_PRODUCTION_ORDERS_BY_PRODUCTION_PROCESS_ID =
  '/GetProductionOrdersByProductionProcessId';

// ECG_CART
export const ECG_CART = '/ECG_Cart';
export const ECG_CART_ITEM = '/ECG_CartItem';
export const ECG_TRANSACTION = '/ECG_Transaction';

// ECG_CategoryFAQ
export const ECG_CATEGORY_FAQ = '/ECG_CategoryFAQ';

// TBLPARTMULTIPLIER
export const TBL_PART_MULTIPLIER = '/tblPartMultiplier';

//TBLPARTCREDITMULTIPLIER
export const TBL_PART_CREDIT_MULTIPLIER = '/tblPartCreditMultiplier';

//TBLCUSTOMERALERT
export const TBL_CUSTOMER_ALERT = '/TblCustomerAlert';

//timeClock
export const TIME_CLOCK = '/TimeClock';
export const GET_NOT_CLOCKED_INACTIVE_USER_LIST =
  '/GetNotClockedInActiveUserList';
export const GET_TIME_CLOCK_REPORT_DATA = '/GetTimeClockReportData';
export const TBL_NOTICE = '/tbl_notice';

//tblPartDrawingLinkVersion
export const TBL_PART_DRAWING_LINK_VERSION = '/tblPartDrawingLinkVersion';
export const GET_LATEST_VERSION_BY_PART_ID = '/GetLatestVersionByPartId';
export const NEED_TO_CREATE_NEW_VERSION = '/NeedToCreateNewVersion';
export const GET_PART_DRAWING_LINK_BY_ORDER_ITEM_ID =
  '/GetPartDrawingLinkByOrderItemId';
export const GET_PART_DRAWING_LINKS = '/GetPartDrawingLinks';

//tblVacation
export const TBL_VACATION = '/tblVacation';
export const BLACKOUT_DAY = '/BlackOutDay';
export const GET_ALL_VACATION_REQUEST = '/GetAllVacationRequest';
export const GET_VACATION_REQUEST_BY_STAFF_ID = '/GetVacationRequestByStaffId';
export const GET_PTO_ESTA_AVAILABILITY = '/GetPTOESTAAvailability';
export const GET_USED_PTO_ESTA_BY_STAFFID_FOR_CURRENT_YEAR =
  '/GetUsedPtoEstaByStaffIdForCurrentYear';

//regions
export const GET_AVERAGE_CUSTOMER_ORDER_BY_STATE =
  '/GetAverageCustomerOrderByState';
export const GET_AVERAGE_CUSTOMER_BY_STATE = '/GetAverageCustomerByState';
export const ADD_SUB_ITEM_TO_PRODUCTION_BY_ORDER_ITEM_ID =
  '/AddSubItemToProductionByOrderItemId';
export const IS_LAST_STATION = '/IsLastStation';

//Kits
export const TBL_PART_KIT = '/TblPartKit';
export const TBL_PART_KIT_ITEM = '/TblPartKitItem';
export const GET_FILTERED_PARTS_KITS = '/GetFilteredPartsKits';
export const GET_KIT_COMPLETE_DETAILS = '/GetKitCompleteDetails';

// part workflow
export const TBL_WORKFLOW_POSITION = '/tblWorkflowPosition';
export const TBL_WORKFLOW = '/tblWorkflow';
export const TBL_PART_REQUEST = '/tblPartRequest';

// TBLPARTLOADINGINSTRUCTION
export const TBL_PART_LOADING_INSTRUCTION = '/tblPartLoadingInstruction';
export const TBL_PART_REQUEST_COMMUNICATION = '/tblPartRequestCommunication';
export const TBL_PART_REQUEST_CHANGE_LOG = '/tblPartRequestChangeLog';

export const START_WORKFLOW_APPROVAL_PROCESS = '/StartWorkflowApprovalProcess';
export const TBL_WORKFLOW_POSITION_PROCESS = '/tblWorkflowPositionProcess';
export const GET_APPROVAL_PART_DETAIL_BY_STAFF_ID =
  '/GetApprovalPartDetailByStaffId';
export const MARK_AS_APPROVE_OR_REJECT_WORKFLOW_PROCESS =
  '/MarkAsApproveOrRejectWorkflowProcess';

export const TBL_DRAFT_PART = '/tblDraftPart';
export const GET_DRAFT_PART_DETAIL_BY_STAFF_ID = '/GetDraftPartDetailByStaffId';
export const GET_PART_DETAIL_BY_STAFF_ID = '/GetPartDetailByStaffId';
export const TBL_DRAFT_PART_IMAGES = '/tblDraftPartImages';
export const TBL_DRAFT_PART_CHANGE_LOG = '/tblDraftPartChangeLog';
export const TBL_DRAFT_PART_COMPONENT = '/tblDraftPartComponent';
export const TBL_DRAFT_PART_DRAWING_LINK_VERSION =
  '/tblDraftPartDrawingLinkVersion';
export const TBL_DRAFT_PART_LOADING_INSTRUCTION =
  '/tblDraftPartLoadingInstruction';
export const TBL_DRAFT_PART_MANUFACTURER = '/tblDraftPartManufacturer';
export const TBL_DRAFT_PART_MULTIPLIER = '/tblDraftPartMultiplier';
export const CAN_ADD_DRAFT_SUB_PART = '/CanAddDraftSubPart';
export const CREATE_PART_BY_DRAFT_PART = '/CreatePartByDraftPart';
export const GET_NEXT_WORKFLOW_POSITION_DATA = '/GetNextWorkflowPositionData';
export const GET_POSITION_HISTORY_BY_PART_ID = '/GetPositionHistoryByPartId';
export const TBL_THOMPSON_DIE_BOARD = '/tblThompsonDieBoard';
export const TBL_THOMPSON_DIE_BOARD_PART = '/tblThompsonDieBoardPart';
export const TBL_DIE_BOARD_SERVICE_DATE = '/tblDieBoardServiceDate';
export const TLKP_CUT = '/TlkpCut';
export const TLKP_HEADER = '/TlkpHeader';
export const TLKP_SIZE = '/TlkpSize';

export const TBL_PART_REQUEST_IMAGES = '/tblPartRequestImages';
export const TBL_PART_CATEGORY_HELP_TEXT = '/tblPartCategoryHelpText';

//notifications
export const TBL_NOTIFICATION = '/tblNotification';
export const GET_NOTIFICATION_SETTING_BY_STAFF_ID =
  '/GetNotificationSettingByStaffId';

export const TBL_USER_NOTIFICATION_SETTING = '/tblUserNotificationSetting';
export const TBL_USER_NOTIFICATION = '/tblUserNotification';

export const ECG_USER = '/ECG_User';
export const SEND_PASSWORD_RESET_EMAIL = '/SendPasswordResetEmail';
export const ECG_SITE = '/ECG_Site';
export const GET_ALL_SITE_DETAIL_WITH_PAGINATION =
  '/GetAllSiteDetailWithPagination';
export const ECG_SITE_USER = '/ECG_SiteUser';

export const ECG_REGION_MANAGER = '/ECG_RegionManager';
export const ECG_CATALOG = '/ECG_Catalog';
export const ECG_CATALOG_ITEM = '/ECG_CatalogItem';

export const UPDATE_INTERMEDIATE_PART_INVENTORY =
  '/UpdateIntermediatePartInventory';
export const TBL_PART_LOT_NUMBER = '/tblPartLotNumber';
export const GET_RACK_BIN_DATA_WITH_LOT_NUMBERS_BY_INTERMEDIATE_PARTID =
  '/GetRackBinDataWithLotNumbersByIntermediatePartId';
export const TBL_INTERMEDIATE_PART_PRODUCTION =
  '/tblIntermediatePartProduction';
export const TBL_PART_RACK_BIN = '/tblPartRackBin';

// Inventory
export const TBL_PART_INVENTORY = '/tblPartInventory';
export const GET_INVENTORY_SCREEN_DATA = '/GetInventoryScreenData';
export const UPDATE_INVENTORY_DATA = '/UpdateInventoryData';
export const GET_INVENTORY_DATES = '/GetInventoryDates';
export const GET_INVENTORY_REPORTS_BY_DATE = '/GetInventoryReportsByDate';

// RMA
export const RMA_ORDER = '/Rma_Order';
export const RMA_ORDER_ITEM = '/Rma_OrderItem';

// WorkingDay
export const TBL_WORKING_DAY = '/tbl_WorkingDay';

// UpdateRackBinData
export const UPDATE_RACK_BIN_DATA = '/UpdateRackBinData';

// warehouse
export const GET_HIGH_LOW_SCREEN_DATA = '/GetHighLowScreenData';
export const UPDATE_WAREHOUSE_INVENTORY = '/UpdateWarehouseInventory';
export const COMPLETE_PROD_AND_CUST_ORDERITEM = '/CompleteProdAndCustOrderItem';

export const TBL_RACK_BIN = '/tblRackBin';
export const TBL_RACK_BIN_SEARCH = '/SearchRackBinData';
export const GET_PART_OR_STORE_ITEM_DETAIL_BY_SLUG =
  '/GetPartOrStoreItemDetailBySlug';

// Event
export const TBL_EVENTS = '/tblEvent';

export const CANCEL_CUSTOMER_ORDER = '/CancelCustomerOrder';
export const RESET_CUSTOMER_ORDER = '/ResetCustomerOrder';
export const PARTIAL_QTY_REQUEST_FOR_CUSTOMER_ORDER =
  '/PartialQtyRequestForCustomerOrder';

export const GET_STAFF_PAID_TIME = '/GetStaffPaidTime';
export const GET_STAFF_PAID_SICK_TIME_BY_DATE_AND_STAFF_ID =
  '/GetStaffPaidSickTimeByDateAndStaffId';

export const TLKP_WIDTH_SETTING = '/TlkpWidthSetting';
export const TLKP_LENGTH_SETTING = '/TlkpLengthSetting';
export const TLKP_QTY_YIELD = '/TlkpQtyYield';
export const GET_QTY_DATA_BY_LENGTH = '/GetQtyDataByLength';
export const GET_LENGTH_DATA_BY_LENGTH = '/GetLengthDataByLength';
export const GET_WIDTH_DATA_BY_WIDTH = '/GetWidthDataByWidth';
export const INVOKE_GET_SUB_ITEM_PRODUCTION_STATION_SP =
  '/InvokeGetSubItemProductionStationSP';

export const TBL_TESTIMONIAL = '/tblTestimonial';
export const TBL_STAFF_NOTIFICATION_STATION = '/tblStaffNotificationStation';
export const DELETE_ALL_STATION_BY_STAFF_ID = '/DeleteAllStationByStaffId';
export const UPDATE_PRODUCTION_NOTES = '/UpdateProductionNotes';
export const EG_HOW_TO_VIDEO = '/EG_HowToVideo';

export const ADD_RE_RULING_ENTRY = '/AddReRulingEntry';
export const GET_PART_OPEN_ORDER_REPORT = '/GetPartOpenOrderReport';
export const GET_PRODUCTION_NOT_COMPLETE_ORDER_ITEM =
  '/GetProductionNotCompleteOrderItem';

export const GET_SCHEDULED_ITEMS_WITHOUT_STATION =
  '/GetScheduledItemsWithoutStation';

// Natural Language Report Generator Endpoint
export const NL_REPORT = '/NLReports';
export const NL_REPORT_GENERATE = '/generate';

// TV Display
export const TBL_MONTHLY_WINNER = '/tbl_MonthlyWinner';
export const RECENT_WINNERS = '/recent-winners';
export const GET_SHIPPED_ORDERS_COUNT_BY_LAST_FOUR_MONTHS =
  '/GetShippedOrdersCountByLastFourMonths';
export const TIME_CLOCK_BASE = '/TimeClock';
export const GET_NOTICE_AND_HOLIDAY_LIST = '/GetNoticeAndHolidayList';
export const HOLIDAY_BASE = '/Holiday';

//Envoy
export const ENVOY = '/envoy';
export const ENVOY_TENDER_SHIPMENT = '/tender';
export const ENVOY_SHIPPING_ESTIMATE = '/shipping-estimate';
export const ENVOY_SHIPPING_ESTIMATE_FOR_ESTIMATE =
  '/shipping-estimate-for-estimate';
